<!-- <p-table styleClass="table-dark-header" [value]="data" [lazy]="true" [dataKey]="'id'" [first]="tableParams.first"
  [rows]="tableParams.rowsPerPage" [paginator]="true" [rowsPerPageOptions]="[10, 25, 50]" [totalRecords]="totalRecords"
  [loading]="loading" [scrollable]="true" scrollHeight="400px" [sortField]="tableParams.sortField"
  [sortOrder]="tableParams.sortOrder" (onPage)="pageChange.emit($event)" (onSort)="sortChange.emit($event)"
  [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"> -->

  <p-table [value]="data" class="p-datatable-sm" [rows]="rows" [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions" styleClass="table-dark-header">
  
  <!-- Dynamic Header -->
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <!-- Dynamic Body with conditional hyperlink and object handling -->
  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr>
      <td *ngFor="let col of columns">
        <!-- Check if the column header is 'Name' to make it a hyperlink -->
        <ng-container *ngIf="col.header === 'Name'; else normalCell">
          <a 
            href="javascript:void(0)" 
            class="p-button-text p-button-link text-decoration-none"
            (click)="onNameClick(row, rowIndex)"
            [title]="'Click to view details for ' + getDisplayValue(row[col.field])">
            {{ getDisplayValue(row[col.field]) }}
          </a>
        </ng-container>
        
        <!-- Normal cell for other columns with proper object handling -->
        <ng-template #normalCell>
          {{ getDisplayValue(row[col.field]) }}
        </ng-template>
      </td>
    </tr>
  </ng-template>
<!-- </p-table> -->

  <!-- Empty State -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length" class="text-center p-3">
        No records found.
      </td>
    </tr>
  </ng-template>

  <!-- Paginator Right Template -->
  <ng-template pTemplate="paginatorleft" let-list>
    <span class="p-ml-2">Showing {{ list.first + 1 }} to {{ list.first + list.rows }} of {{ list.totalRecords }}</span>
  </ng-template>
</p-table>